import { Constants } from '@pwc/pwc-deals-web-common';
import DROPPABLE_LOCATION_IDS from './droppableLocationIds';

import { generateDroppableLocationIdWithSection } from './generateDroppableLocationIdWithSection';

const numericSortCallback = (a, b) => (a.order > b.order ? 1 : -1);

export const layoutTypeToDroppableLocationIdMap = {
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_ID,
  ],
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN]: [
    DROPPABLE_LOCATION_IDS.DOUBLE_COLUMN_FIRST_AREA_ID,
    DROPPABLE_LOCATION_IDS.DOUBLE_COLUMN_SECOND_AREA_ID,
  ],
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_80,
  ],
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_60,
  ],
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_40,
  ],
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_TEXT_OVERFLOW_AREA,
  ],
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_TWO_COLUMN_AREA_67_33,

  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_60,
  ],
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40]: [
    DROPPABLE_LOCATION_IDS.SINGLE_COLUMN_AREA_40,
  ],
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_40_1A_R_60_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_67_1A_R_33_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_80_1A_R_20_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_T_80_1A_B_20_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_T_60_1A_B_40_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_T_20_1A_B_80_1A,
  [Constants.SECTION_LAYOUT_TYPE.THREE_ROWS]: DROPPABLE_LOCATION_IDS.THREE_ROWS,
  [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN]:
    DROPPABLE_LOCATION_IDS.THREE_COLUMN,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_50_2A_R_50_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_T_50_2A_B_50_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_67_2A_R_33_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A]:
    DROPPABLE_LOCATION_IDS.TWO_ROW_T_50_1A_B_50_2A,

  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_L_50_3A_R_50_1A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_TWO_ROW_50_2A_50_2A,
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A]:
    DROPPABLE_LOCATION_IDS.TWO_COLUMN_TWO_ROW_67_2A_33_2A,

  [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW]:
    DROPPABLE_LOCATION_IDS.THREE_COLUMN_TWO_ROW,
};

const findAreaNeighbors = (allItems, area, sectionOrder) => {
  const neighbors = {
    areaAbove: null,
    areaBelow: null,
  };
  const areaOrder = area.slice(-1);
  const areaWithoutOrder = area.slice(0, -1);
  if (areaWithoutOrder.includes('bottom')) {
    // find area above
    const areaAbove = allItems.find((item) => item.includes('top'));
    neighbors.areaAbove = `${areaAbove}-${sectionOrder}`;
    return neighbors;
  }
  if (areaWithoutOrder.includes('top')) {
    // find area below
    const areaBelow = allItems.find((item) => item.includes('bottom'));
    neighbors.areaBelow = `${areaBelow}-${sectionOrder}`;
    return neighbors;
  }
  const topBottomNeighbors = allItems.filter(
    (item) => item.includes(areaWithoutOrder) && item !== area
  );
  if (topBottomNeighbors.length >= 1) {
    topBottomNeighbors.forEach((neighbor) => {
      const neighborAreaOrder = neighbor.slice(-1);
      if (neighborAreaOrder > areaOrder) {
        neighbors.areaBelow = `${neighbor}-${sectionOrder}`;
      } else if (neighborAreaOrder < areaOrder) {
        neighbors.areaAbove = `${neighbor}-${sectionOrder}`;
      }
    });
  }
  return neighbors;
};

const generateDroppableLocationSetForSection = (section) => {
  const baseColumn = { direction: 'vertical' };
  const { layoutType } = section;
  const droppableLocations = {};
  const droppableLocationIds = layoutTypeToDroppableLocationIdMap[layoutType];
  droppableLocationIds.forEach((dropLocId, index, allLocIds) => {
    const position = index + 1;
    const dropLocIdWithOrder = generateDroppableLocationIdWithSection(
      dropLocId,
      section.order
    );
    const { areaAbove, areaBelow } = findAreaNeighbors(
      allLocIds,
      dropLocId,
      section.order
    );
    droppableLocations[dropLocIdWithOrder] = {
      ...baseColumn,
      position,
      id: dropLocIdWithOrder,
      areaAbove,
      areaBelow,
      libraryItemIds: section.items
        .filter((item) => item.analysisColumn === position)
        .sort(numericSortCallback)
        .map((item) => item.id),
    };
  });
  return droppableLocations;
};

export default generateDroppableLocationSetForSection;
